import React from 'react';

class TermSelect extends React.Component {

    render() {
        return (
            <option value={this.props.term.STRM}>
                {this.props.term.TERM_DESCR30}
            </option>
        );
    }
}

export default TermSelect;
